<template>
  <DefaultLayout background-image="twoPeople">
    <div class="relative flex flex-col items-center h-full px-4 mt-10">
      <div class="flex flex-col items-center justify-start flex-1">
        <img
          :src="logo"
          alt="logo"
          class="w-24 mx-auto mb-3 logo-jm md:w-32 lg:w-40"
          :class="{ 'slide-from-top': animateLogo }"
        />
      </div>

      <div
        class="flex flex-col justify-center items-center bg-jm_dark_green rounded-t-3xl p-4 w-full fixed left-0 right-0 bottom-0 max-w-none min-h-[20vh] tall:min-h-[32vh]"
      >
        <img
          :src="shotMachineNew"
          alt="shot machine"
          class="mx-auto mb-2 shot-machine animated-content h-[3.8rem] w-auto max-w-[52vw] object-contain tall:h-[5.25rem] tall:max-w-[60vw]"
          :class="{ 'slide-from-bottom': animateShotMachine }"
        />
        <PlayButton
          class="mb-4 animated-content"
          :class="{ 'slide-from-bottom': animateShotMachine }"
        />
      </div>
    </div>
  </DefaultLayout>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import PlayButton from "@/components/PlayButton.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import logo from "@/assets/images/misc/logo_jm.svg";
import shotMachineNew from "@/assets/images/misc/logo_jm_shot_machine.svg";
import { useGlobalStore } from "@/stores/global";
import { useGameTracking } from "@/composables/useGameTracking";

const animateLogo = ref(false);
const animateShotMachine = ref(false);
const globalStore = useGlobalStore();
const { kpiTracker } = useGameTracking();

onMounted(() => {
  kpiTracker.setSelectedPerson(1);
  globalStore.resetGame(1);

  setTimeout(() => {
    animateLogo.value = true;
  }, 200);

  setTimeout(() => {
    animateShotMachine.value = true;
  }, 400);
});
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.sass";

.logo-jm {
  opacity: 0;
  transform: translateY(-100px);
  transition: opacity 1s ease, transform 1s ease;
}

.slide-from-top {
  opacity: 1 !important;
  transform: translateY(0) !important;
}

.shot-machine {
  transition: transform 1.5s ease, opacity 1.5s ease;
}

.animated-content {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1.5s ease, transform 1.5s ease;
}

.slide-from-bottom {
  opacity: 1 !important;
  transform: translateY(0) !important;
}
</style>
